export const SORT_DEC = -1;
export const SORT_INC = +1;
export const EXTRA_OPTION_ID = -1;
export const OPTION_ELIPSIS_MAX_LENGTH = 38;
export const ZERO_OPTION_ID = 0;
export const RADIX_PARAM = 10;
export const RADIX_HEX_PARAM = 16;
export const SEARCH_TERM_MIN_LENGTH = 2;
export const SHORT_PLAIN_TEXT_50_LENGTH = 50;
export const SHORT_PLAIN_TEXT_64_LENGTH = 64;
export const SHORT_PLAIN_TEXT_150_LENGTH = 150;
export const SHORT_PLAIN_TEXT_200_LENGTH = 200;
export const SHORT_PLAIN_TEXT_LENGTH = 255;
export const MEDIUM_PLAIN_TEXT_2000_LENGTH = 2000;
export const MEDIUM_PLAIN_TEXT_LENGTH = 2048;
export const LONG_PLAIN_TEXT_LENGTH = 4096;
export const SHORT_RICH_TEXT_LENGTH = 16384;
export const LONG_RICH_TEXT_LENGTH = 65535;
export const MIN_ACCESS_CODE_LENGTH = 6;
export const MIN_PODIUM_ACCESS_CODE_LENGTH = 8;
export const MIN_PASS_CODE_LENGTH = 63;
export const MEDIUM_PASS_CODE_LENGTH = 128;
export const MAX_ACCESS_CODE_LENGTH = 99;
export const INPUT_DEBOUNCE_TIME = 1000;
export const MINIMAL_SEARCH_LENGTH = 2;
export const FONT_SIZE_CODE_EDITOR = 14;
export const APPSYNC_UPDATE_DEBOUNCE_TIME = 1000;
export const ONE_MINUTE = 60 * 1000;
export const MAX_MEETING_DATES_LIST_LENGTH = 20;
export const HEADER_HEIGHT = 92;
export const SCROLL_HEADER_HEIGHT = 130;
export const MAX_THEME_CODE_FILE_SIZE = 1024;
export const MAX_REPORT_FILE_SIZE = 20;
export const ONE_MIB = 1024 * 1024;
export const MAX_CUSTOM_FIELD_OPTIONS_COUNT = 250;
export const MAX_EVENT_ATTRIBUTE_VALUES_COUNT = 25;
export const SAVED_ROUTE_STORAGE_NAME = 'SAVED_ROUTE';
export const AUTH_ROUTE = '/auth';
export const OE_CENTRAL_DOMAIN = 'oe-central.com';
export const AMAZON_COGNITO_USER_POOLS = 'AMAZON_COGNITO_USER_POOLS';
export const APPSYNC_CONNECTION_CLOSED_MESSAGE = 'Connection closed';
export const UNAUTHORIZED_EXCEPTION_MESSAGE = 'UnauthorizedException';
export const CLONED_CONNECTION = 'cloned-connection';
export const TOOLTIP_GROUP_USERS_COUNT = 20;
export const TIME_TO_HIGHLIGHT_INCOMPLETE_ATTENDEE = 600000;
export const MAX_SAFE_TIMEOUT_DELAY = 2147483647;
export const MAX_CUSTOM_HTML_PAGE_FILE_SIZE = 20 * ONE_MIB;
export const HUB_CUSTOM_HTML_IFRAME_HEIGHT_DEFAULT = 500;
export const HUB_CUSTOM_HTML_IFRAME_HEIGHT_MIN = 150;
export const HUB_CUSTOM_HTML_IFRAME_HEIGHT_MAX = 3000;
export const YES = 'Yes';
export const NO = 'No';
export const NONE = 'None';
export const DAYS_COUNT_BEFORE_ANONYMIZATION_MIN = 30;
export const DAYS_COUNT_BEFORE_ANONYMIZATION_MAX = 9999;
export const MIXPANEL_TRACKING_ENABLED = 'MIXPANEL_TRACKING_ENABLED';
export const ZOOM_USER_HOST_KEY_TIMEOUT_DELAY = 600000;
export const ID_TOKEN = 'idToken';
export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';
export const USER_STATE = 'userState';
export const CLIENT_ID = 'clientId';
export const DEFAULT = 'Default';
export const CUSTOM = 'Custom';
export const OFFSET_WITH_GEOGRAPHY = 'Offset with geography';
export const ZOOM_EMAIL_MAX_LENGTH = 128;
export const BLUEPRINT_SPACE_FROM_LEFT = 10;
export const COMPLINACE_EMAIL_MAX_EMAILS_AMOUNT = 10;
export const ORDERBOOKING_EMAIL_MAX_EMAILS_AMOUNT = 10;
export const NOT_AVAILABLE_STRING = 'n/a';
export const CHANGED = 'Changed';
export const UNCHANGED = 'Unchanged';
export const POPULATED = 'Populated';
export const EMPTY = 'Empty';
export const PANELIST_LINK = 'Panelist Link';
export const AUTO_SYNC = 'Auto Sync';
export const NOT_FOUND_STATUS = 404;

export enum EnablementStatus {
    ENABLED = 'enabled',
    DISABLED = 'disabled',
    ENABLED_UPPERCASE = 'Enabled',
    DISABLED_UPPERCASE = 'Disabled',
    DISPLAYED = 'displayed',
    NOT_DISPLAYED = 'not displayed',
    HIDDEN = 'hidden',
}

export enum LinkTargetValue {
    BLANK = '_blank',
    SELF = '_self',
    PARENT = '_parent',
    TOP = '_top',
}

export enum KeyboardEvents {
    ENTER = 'Enter',
    BACKSPACE = 'Backspace'
}

export enum ConnectionVersion {
    V1 = 'V1',
    V2 = 'V2',
    V2_SINGLE = 'V2_SINGLE',
    V2_MULTIPLE = 'V2_MULTIPLE',
}

export enum ProjectCSPNonceDerictives {
   OEC_DRAG_DROP_STYLES = 'OECDragDropStyles'
}